// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage } from "react-intl";

export const LensPlusEnrolledTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.lensPlusEnrolledTitle"
        description="Lens plus enrolled title."
        defaultMessage="Enrolled in Lens+ Payouts"
    />
);
LensPlusEnrolledTitle.displayName = "LensPlusEnrolledTitle";

export const LensPlusEnrolledDescription = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.lensPlusEnrolledDescription"
        description="Lens plus enrolled description."
        defaultMessage="This Lens is Exclusive to Lens+ subscribers and earns monthly, based on their activity."
    />
);
LensPlusEnrolledDescription.displayName = "LensPlusEnrolledDescription";

export const TopPerformerEnrolledTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.topPerformerEnrolledTitle"
        description="Top performer enrolled title."
        defaultMessage="Enrolled in Top Performer Payouts"
    />
);
TopPerformerEnrolledTitle.displayName = "TopPerformerEnrolledTitle";

export const TopPerformerEnrolledDescription = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.topPerformerEnrolledDescription"
        description="Top performer enrolled description."
        defaultMessage="This Lens earns a one-time award when it ranks as a Top Performer."
    />
);
TopPerformerEnrolledDescription.displayName = "TopPerformerEnrolledDescription";

export const ViewInMonetization = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.viewInMonetization"
        description="View in monetization."
        defaultMessage="View in Monetization"
    />
);
ViewInMonetization.displayName = "ViewInMonetization";

export const LensPlusUsersTile = (props: { month: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.lensPlusUsersTile"
        description="Lens plus users tile."
        defaultMessage="Lens+ Users · {month}"
        values={props}
    />
);
LensPlusUsersTile.displayName = "LensPlusUsersTile";

export const MonthScoreTile = (props: { month: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.monthScoreTile"
        description="Month score tile."
        defaultMessage="{month} Score"
        values={props}
    />
);
MonthScoreTile.displayName = "MonthScoreTile";

export const TotalEarnedTile = (props: { lensName: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.totalEarnedTile"
        description="Total earned tile."
        defaultMessage="Total earned from {lensName}"
        values={props}
    />
);
TotalEarnedTile.displayName = "TotalEarnedTile";

export const ResetsOn = (props: { date: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.resetsOn"
        description="Resets on."
        defaultMessage="Resets {date}"
        values={props}
    />
);
ResetsOn.displayName = "ResetsOn";

export const ScoreFormula = (props: { users: ReactNode; signups: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.scoreFormula"
        description="Score formula."
        defaultMessage="{users} users + {signups} signups × 100"
        values={props}
    />
);
ScoreFormula.displayName = "ScoreFormula";

export const PaidOn = (props: { date: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.paidOn"
        description="Paid on."
        defaultMessage="Paid {date}"
        values={props}
    />
);
PaidOn.displayName = "PaidOn";

export const MonthlyPayoutsSince = (props: { count: number; month: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.monthlyPayoutsSince"
        description="Monthly payouts since."
        defaultMessage="{count, plural, one {# monthly payout} other {# monthly payouts}} since {month}"
        values={props}
    />
);
MonthlyPayoutsSince.displayName = "MonthlyPayoutsSince";

export const PayoutHistoryHeading = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.payoutHistoryHeading"
        description="Payout history heading."
        defaultMessage="Payout history"
    />
);
PayoutHistoryHeading.displayName = "PayoutHistoryHeading";

export const MonthColumn = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.monthColumn"
        description="Month column."
        defaultMessage="Month"
    />
);
MonthColumn.displayName = "MonthColumn";

export const LensPlusUsersColumn = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.lensPlusUsersColumn"
        description="Lens plus users column."
        defaultMessage="Lens+ Users"
    />
);
LensPlusUsersColumn.displayName = "LensPlusUsersColumn";

export const SubscriptionsColumn = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.subscriptionsColumn"
        description="Subscriptions column."
        defaultMessage="Subscriptions"
    />
);
SubscriptionsColumn.displayName = "SubscriptionsColumn";

export const LensPlusScoreColumn = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.lensPlusScoreColumn"
        description="Lens plus score column."
        defaultMessage="Lens+ Score"
    />
);
LensPlusScoreColumn.displayName = "LensPlusScoreColumn";

export const PayoutColumn = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.payoutColumn"
        description="Payout column."
        defaultMessage="Payout"
    />
);
PayoutColumn.displayName = "PayoutColumn";

export const StatusInProgress = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.statusInProgress"
        description="Status in progress."
        defaultMessage="In progress"
    />
);
StatusInProgress.displayName = "StatusInProgress";

export const StatusPending = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.statusPending"
        description="Status pending."
        defaultMessage="Pending"
    />
);
StatusPending.displayName = "StatusPending";

export const StatusPaid = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.statusPaid"
        description="Status paid."
        defaultMessage="Paid"
    />
);
StatusPaid.displayName = "StatusPaid";

export const StatusNone = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.statusNone"
        description="Status none."
        defaultMessage="No payout"
    />
);
StatusNone.displayName = "StatusNone";

export const LensPlusFootnote = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.lensPlusFootnote"
        description="Lens plus footnote."
        defaultMessage="Payouts are processed monthly, by the 5th of the following month, for the previous month's activity. Enrollment does not guarantee payout."
    />
);
LensPlusFootnote.displayName = "LensPlusFootnote";

export const AmountAwarded = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.amountAwarded"
        description="Amount awarded."
        defaultMessage="Amount awarded"
    />
);
AmountAwarded.displayName = "AmountAwarded";

export const QualifiedPostersPaid = (props: { count: number; paid: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.qualifiedPostersPaid"
        description="Qualified posters paid."
        defaultMessage="{count, plural, one {# qualified poster} other {# qualified posters}} · {paid}"
        values={props}
    />
);
QualifiedPostersPaid.displayName = "QualifiedPostersPaid";

export const NoPayoutsYet = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.noPayoutsYet"
        description="No payouts yet."
        defaultMessage="No payouts yet"
    />
);
NoPayoutsYet.displayName = "NoPayoutsYet";

export const NoAwardsYet = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.noAwardsYet"
        description="No awards yet."
        defaultMessage="No awards yet"
    />
);
NoAwardsYet.displayName = "NoAwardsYet";

export const EmptyValue = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.emptyValue"
        description="Empty value."
        defaultMessage="—"
    />
);
EmptyValue.displayName = "EmptyValue";

export const MonthStatsError = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.monthStatsError"
        description="Month stats error."
        defaultMessage="This month's stats are temporarily unavailable. Please try again later."
    />
);
MonthStatsError.displayName = "MonthStatsError";

export const MissingPayoutBreakdown = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.enrolledProgram.missingPayoutBreakdown"
        description="Missing payout breakdown."
        defaultMessage="Some months have payout amounts but no activity breakdown. A dash (—) means the Lens+ users, subscriptions, or score is unavailable for that month."
    />
);
MissingPayoutBreakdown.displayName = "MissingPayoutBreakdown";
